var Mixins = {



    // sql date to display time
     /**
     * If there are validation errors, then sort the ones to show into the v-validate errors array. 
     * any validation errors that are not customer facing, just populates a default error into the 'customError' variable. 
     * any non validation error gets added to the customError variable, if it's customer facing
     * @type {object} graph response
     * @type {integer} graph api fields to local fields error map
     * @return BOOL 
     */

    validateGraphResponse(result,error_to_error) 
    {

        //Validation error
        if(result.data.errors && result.data.errors.length){
            for (var i = 0, len = result.data.errors.length; i < len; i++) {
                if(result.data.errors[i].message == "validation"){
                    for (var index in result.data.errors[i].validation){ 
                        if(error_to_error[index]){
                            this.errors.add({field:error_to_error[index],msg:result.data.errors[i].validation[index][0]});
                        }else{
                            this.$bus.$emit('error_message', "An error occured while trying to complete your request.");
                        }
                    }
                }
                if(result.data.errors[i].customer_facing === true){
                  this.$bus.$emit('error_message', result.data.errors[i].message);
                }
            }

            return false;
        }

        return true;  

    },

    /*
    *  @param Currency currency - a GraphQL currency type
    *  @param Int value - the value of the item in it's lowest denomination
    *  @return String - display string of the value in it's currency.
    */

    getPriceDisplay(currency, o_value){

        let value = (o_value/currency.denomination);
        let newvalue = (value < 0 ? Math.abs(value) : value).toFixed(2);
        return (value >= 0 ? '' : '-') + currency.symbol + (newvalue < 0 ? Math.abs(newvalue) : newvalue);
        
    },

    /**
     * Get the display value of a price modifier
     * @type {Object} Price Modifier
     * @type {integer} Qunatity
     * @return String 
     */

    getPriceModifierDisplayValue(price_modifier, quantity) {

        return this.getPriceDisplayValue(price_modifier.Currency.symbol, price_modifier.price, quantity, price_modifier.Currency.denomination);
    },

    /**
     * Get the display value of a currency
     * @type {string} Symbol
     * @type {integer} Price
     * @type {integer} Quantity
     * @type {integer} currency denomination
     * @return String 
     */

    getPriceDisplayValue(currency_symbol, price, quantity, currency_denomination) {
        return currency_symbol + ((price * quantity) / currency_denomination).toFixed(2);
    },

    /**
     * Check if the user has permission to sell a card
     * @return Boolean
     */
    sellCardPermission() {
        return this.$store.getters.getUserPermissions.some(
            permission => permission.name === 'create-balance-adjustments'
        );
    },

    /**
     * Check if the user has permission to redeem a card
     * @return Boolean
     */
    redeemCardPermission() {
        return this.$store.getters.getUserPermissions.some(
            permission => permission.name === 'create-negative-balance-adjustments'
        );
    },

    /**
     * Check if the user has permission to redeem a ticket
     * @return Boolean
     */
    redeemTicketPermission() {
        return this.$store.getters.getUserPermissions.some(
            permission => permission.name === 'redeem-tickets'
        );
    },

    /**
     * Check if the user has permission to view redemptions
     * @return Boolean
     */
    userCanViewRedemptions()
    {
        return this.$store.getters.getUserPermissions.some(p => p.name === 'view_redemptions')
    }

}

export default Mixins;